import uuidV4 from 'uuid/v4';

export default function generateUuid() {
  const uuid = uuidV4();
  return uuid.replace(/-/g, '');
}
